import { render, staticRenderFns } from "./UserHome.vue?vue&type=template&id=534c4c50&scoped=true"
import script from "./UserHome.vue?vue&type=script&lang=js"
export * from "./UserHome.vue?vue&type=script&lang=js"
import style0 from "./UserHome.vue?vue&type=style&index=0&id=534c4c50&prod&lang=scss&scoped=true"
import style1 from "./UserHome.vue?vue&type=style&index=1&id=534c4c50&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534c4c50",
  null
  
)

export default component.exports